import { createContext } from 'react';

import { NotificationConfig, Notification } from 'utils/interfaces/commonInterfacesAndTypes';

export type NotificationContextType = {
   notification: Notification | null;
   display: (notificationConfig: NotificationConfig, onNotificationFinish?: () => void) => void;
};

const NotificationContext = createContext<NotificationContextType>({
   notification: null,
   display: () => {
      // empty
   },
});

export default NotificationContext;
